import api from '@/lib/axios';

export const cajaService = {
  async open(data: { branchId: string; openedById: string; initialCash: number; note?: string }) {
    const response = await api.post('/cash-register/open', data);
    return response.data;
  },

  async close(id: string, data: { closedById: string; countedCash: number; note?: string }) {
    const response = await api.patch(`/cash-register/${id}/close`, data);
    return response.data;
  },

  async getStatus(branchId: string, userId?: string) {
    const response = await api.get('/cash-register/status', { params: { branchId, userId } });
    return response.data;
  },

  async getOpenRegisters(branchId: string) {
    const response = await api.get('/cash-register/open-registers', { params: { branchId } });
    return response.data;
  },

  async history(branchId: string, page?: number, limit?: number) {
    const response = await api.get('/cash-register/history', { params: { branchId, page, limit } });
    return response.data;
  },

  async findById(id: string) {
    const response = await api.get(`/cash-register/${id}`);
    return response.data;
  },

  async addMovement(id: string, data: { type: string; amount: number; reason: string; userId: string }) {
    const response = await api.post(`/cash-register/${id}/movement`, data);
    return response.data;
  },

  async getMovements(id: string) {
    const response = await api.get(`/cash-register/${id}/movements`);
    return response.data;
  },
};
